import React from 'react'
import { StyledForm, StepperButton, StyledFormContainer, StepperButtonContainer } from './styles'

const FormNumberStep = ({ placeholder, step, value, onChangeVal, ...rest }) => {

  function handleKeyDown(event) {
    event.preventDefault()

    // handle up and down arrow
    if (event.keyCode === 38) {
      handleIncrement()
    } else if (event.keyCode === 40) {
      handleDecrement()
    }

    if (event.keyCode === 8 || event.keyCode === 46) {
      onChangeVal("")
    }
  }

  function handleIncrement() {
    const currentValue = value ? parseInt(value.replace(/,/g, "")): 0
    const incrementedValue = currentValue + parseInt(step)
    const formattedValue = new Intl.NumberFormat('en-US').format(incrementedValue);
    onChangeVal(formattedValue)
  }

  function handleDecrement() {
    const currentValue = value ? parseInt(value.replace(/,/g, "")) : 0
    const decrementedValue = currentValue - parseInt(step)
    if (decrementedValue < 0) {
      onChangeVal(0)
    } else {
      const formattedValue = new Intl.NumberFormat('en-US').format(decrementedValue);
      onChangeVal(formattedValue)
    }
  }

  return (
    <StyledFormContainer>
      <StyledForm
        type={'text'}
        placeholder={placeholder}
        value={value}
        onChange={e => onChangeVal(e.target.value)}
        onKeyPress={e => e.preventDefault()}
        onKeyDown={e => handleKeyDown(e)}
        {...rest}
      />
      <StepperButtonContainer>
        <StepperButton onClick={handleIncrement} rad={'1px 1px 0 0'}>&#x25B2;</StepperButton>
        <StepperButton onClick={handleDecrement} rad={'0 0 1px 1px'}>&#x25BC;</StepperButton>
      </StepperButtonContainer>
  </StyledFormContainer>
)}

export default FormNumberStep